'use client';

import styles from './ImageModal.module.css';

export const ImageModal = ({
  className,
  children,
  ctaText,
  ctaOnClick,
  tone,
}: {
  className?: string;
  children?: React.ReactNode | undefined;
  ctaText?: string;
  ctaOnClick?: () => void;
  /** Set by the Eudemonia booth. Unset keeps the light card used on Ring PRO. */
  tone?: 'light' | 'dark';
}) => {
  // const { width } = useWindowSize();
  return (
    <div
      className={[styles.root, tone === 'dark' ? styles.dark : '', className]
        .filter(Boolean)
        .join(' ')}
      data-offers-tone={tone || undefined}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      <div className="children-container">{children}</div>
      {ctaText && ctaText.length ? (
        <div className="sticky-container">
          <button onClick={ctaOnClick}>{ctaText}</button>
        </div>
      ) : null}
    </div>
  );
};
